import React from 'react';

const VIEWPORT_HEIGHT_PADDING = 50; // maintain this distance between bottom of container and viewport

export interface Props {
    onViewportHeightAdjustment?: (diff: number) => void;
    onDocumentClick?: (event: MouseEvent) => void;
    children: React.ReactNode;
}

export default class OnsiteNotificationsDropdown extends React.Component<Props> {
    static readonly defaultProps: Partial<Props> = {
        onViewportHeightAdjustment: () => {},
        onDocumentClick: () => {},
    };

    contentNode = React.createRef<HTMLDivElement>();

    componentDidMount() {
        if (this.props.onDocumentClick) {
            document.addEventListener('click', this.props.onDocumentClick);
        }
        this.calculateHeight();
    }

    componentWillUnmount() {
        if (this.props.onDocumentClick) {
            document.removeEventListener('click', this.props.onDocumentClick);
        }
    }

    getViewportHeight() {
        return Math.max(
            (document.documentElement && document.documentElement.clientHeight) || 0,
            window.innerHeight || 0
        );
    }

    calculateHeight() {
        if (!this.contentNode.current || !this.props.onViewportHeightAdjustment) return;

        const rect = this.contentNode.current.getBoundingClientRect();
        const diff = this.getViewportHeight() - rect.bottom - VIEWPORT_HEIGHT_PADDING;

        if (diff < 0) {
            this.props.onViewportHeightAdjustment(diff);
        }
    }

    render() {
        return (
            <div className="onsite-notifications__dropdown" ref={this.contentNode}>
                {this.props.children}
                <div className="onsite-notifications__tip" />
            </div>
        );
    }
}
